export default {
  translation: {
    'form.validation.required': '{{field_name}} 是必須的',
    'form.validation.format':
      '{{field_name}}格式錯誤，內容包含系統不支援的符號',
    'form.validation.maxlength': '{{field_name}} 太長',
    'form.validation.minlength': '{{field_name}} 太短',
    'form.validation.invalid': '{{field_name}} 無效',
    'form.validation.unique': '{{field_name}} 已被選用，請重新輸入。',
    'membership.profile.optional_field': '(選填)',
    'dropdown.hint': '請選擇',

    'member_points.title': '會員點數',
    'member_points.unit': '點',
    'member_points.point_balance': '現有總點數',
    'member_points.point_history': '點數記錄',
    'member_points.fields.date': '日期',
    'member_points.rule': '點數規則說明',
    'member_points.display.expire_point': '點將於',
    'member_points.display.successive_expire_point': '點將於',
    'member_points.fields.expire': '到期',
    'member_points.fields.expired': '點數過期',
    'member_points.fields.successive_expire': '後陸續到期',
    'member_points.fields.remarks': '點數更動原因',
    'member_points.fields.value': '點數',
    'member_points.fields.expiry_date': '到期日',
    'member_points.fields.member_point_expired': '點數過期',
    'member_points.fields.auto_reward': '於訂單',
    'member_points.fields.auto_reward_seconds': '獲得點數',
    'member_points.no_data': '沒有任何記錄',
    'member_points.equal_cash': '等值 {{money}}',
    'member_points.redeem_cash_description':
      '{{costPoint}} 點可折抵 {{discountMoney}}。',
    'member_points.fields.revert_member_point': '回補點數；已取消訂單',
    'member_points.fields.revert_member_point.return': '回補點數；已退貨訂單',
    'member_points.fields.revert_member_point.order_split':
      '回補點數；來自拆單',
    'member_points.fields.revert_member_point.order_edit':
      '回補點數；來自編輯訂單',
    'member_points.fields.revert_member_point.return_order_revert':
      '回補點數；來自退貨',
    'member_points.fields.revert_member_point.order': '回補點數；來自訂單',
    'member_points.fields.product_review_reward': '完成訂單 <a></a> 的評價',
    'member_points.fields.member_info_reward': '會員資料獎賞會員點數',
    'store_credits.fields.display.never_expired': '永不過期',
    'member_points.fields.order_redeemed': '使用點數兌換贈品於訂單',
    'member_points.fields.redeemed_to_cash': '使用點數折現於訂單',
    'member.center.load.more': '載入更多',
    'store_credits.fields.never_expires_point': '點永不過期',
    'member_points.display.redeem_btn': '兌換贈品',
    'promotions.page.term.confirm': '確認',

    'store_credits.title': '商店購物金',
    'store_credits.credit_balance': '現有購物金',
    'store_credits.credit_history': '購物金紀錄',
    'store_credits.fields.date': '日期',
    'store_credits.fields.remarks': '購物金項目',
    'store_credits.fields.value': '購物金款項',
    'store_credits.fields.expiry_date': '到期日',
    'store_credits.fields.balance': '購物金餘額',
    'store_credits.fields.order_prefix': '已使用購物金在此筆訂單',
    'store_credits.fields.welcome_credit': '新加入會員購物金',
    'store_credits.fields.member_referral_credit': '推薦新顧客進行消費',
    'store_credits.fields.member_info_quick_completion_credit':
      '會員資料獎賞購物金',
    'store_credits.fields.welcome_member_referral_credit':
      '透過推薦連結註冊成功',
    'store_credits.fields.birthday_credit': '生日購物金',
    'store_credits.fields.user_credit_expired': '購物金過期',
    'store_credits.fields.never_expires': '永不過期',
    'store_credits.fields.auto_reward_prefix': '訂單 ',
    'store_credits.fields.auto_reward': ' 獲得購物金',
    'store_credits.fields.revert_credit': '回補購物金；已取消訂單',
    'store_credits.fields.revert_credit.return': '回補購物金；已退貨訂單',
    'store_credits.fields.revert_credit.order_split': '回補購物金；來自拆單',
    'store_credits.fields.revert_credit.order_edit': '回補購物金；來自編輯訂單',
    'store_credits.fields.revert_credit.order': '回補購物金；來自訂單',
    'store_credits.fields.revert_credit.return_order_revert':
      '回補購物金；來自退貨',
    'store_credits.fields.product_review_reward': '完成訂單 <a></a> 的評價',
    'store_credits.no_data': '沒有任何記錄',
    'store_credits.bulk_imported': '手動新增購物金',

    'member_point.list.empty.description': '結帳累積點數獲得更多優惠！',
    'store_credits.list.empty.description': '結帳累積購物金獲得更多優惠！',
    'member_center.list.empty.buttonText': '馬上逛逛',
    // Member Profile
    'member_profile.member_info.title': '會員資料獎賞',
    'member_profile.member_info.name': '姓名',
    'member_profile.member_info.email': '電郵',
    'member_profile.member_info.mobile': '手機號碼',
    'member_profile.member_info.gender': '性別',
    'member_profile.member_info.birthday': '生日',
    'member_profile.member_info.symbol': '、',
    'member_profile.member_info.hint.both':
      '填寫會員資料「{{fields}}」，並且訂閱「{{subscriptions}}」，完成後可獲得 {{rewards}}',
    'member_profile.member_info.hint.fields_only':
      '填寫會員資料「{{fields}}」，完成後可獲得 {{rewards}}',
    'member_profile.member_info.hint.subscriptions_only':
      '訂閱「{{subscriptions}}」，完成後可獲得 {{rewards}}',
    'member_profile.member_info.sent': '待資料檢查完成，將發放會員資料獎賞！',
    'member_profile.member_info.user_credits': '${{count}} 元購物金',
    'member_profile.member_info.member_points': '{{count}} 點會員點數',
    'member_profile.member_info.coupons': '{{count}} 張優惠券',
    'member_profile.member_info.subscription.email': '電郵',
    'member_profile.member_info.subscription.sms': 'SMS',
    'member_profile.member_info.subscription.line': 'LINE',
    'member_profile.member_info.subscription.facebook': 'Facebook Messenger',
    'member_profile.member_info.subscription.whatsapp': 'WhatsApp',
    'member_profile.member_referral.discount': '會員推薦優惠',
    'member_profile.member_referral.rules': '活動規則說明',
    'member_profile.member_referral.code.copy_and_share':
      '複製並分享連結給朋友，推薦對象和你將獲得購物金。',
    'member_profile.member_referral.code.remarks': '活動規則說明',
    'member_profile.member_referral.generate': '推薦連結',
    'member_profile.member_referral.generate.success': '產生成功',
    'member_profile.member_referral.copy': '複製連結',
    'member_profile.member_referral.copy.success': '複製成功',
    'membership.profile.email': '電郵',
    'membership.profile.verification_hint':
      '若您更改電郵，儲存後需進行驗證，完成驗證後電郵將會立即更新為 {{unconfirmedEmail}}',
    'membership.profile.verified_success': '驗證完成',
    'membership.profile.not_verified_yet': '尚未驗證',
    'membership.profile.send_verification_email': '發送驗證信',
    'users.save.email_verification.success':
      '變更已儲存, 電郵會在驗證成功後更新',
    'users.save.email_verification.send': '驗證信已寄出',
    'user.sign_up.email_verification.dialog.title': '驗證信已寄至 {{email}}',
    'user.sign_up.email_verification.dialog.description':
      '請立即完成收信驗證，即可更新電郵！若沒收到，請再次更改電郵並儲存。',
    'user.sign_up.email_verification.dialog.confirm': '確定',

    'users.membership.member_info.title': '會員資料獎賞',
    'users.membership.member_info.hint':
      '填寫以下會員資訊：{{fields}}，填寫完畢可獲得 {{rewards}}',
    'users.membership.member_info.sent': '待資料檢查完成，將發放會員資料獎賞！',
    'users.membership.member_info.symbol': '、',
    'users.membership.member_info.name': '姓名',
    'users.membership.member_info.email': '電郵',
    'users.membership.member_info.mobile': '手機號碼',
    'users.membership.member_info.gender': '性別',
    'users.membership.member_info.gender.male': '男',
    'users.membership.member_info.gender.female': '女',
    'users.membership.member_info.gender.other': '不透露',
    'users.membership.member_info.birthday': '生日',
    'users.membership.member_info.password': '密碼',
    'users.membership.member_info.password.change': '設定新的密碼',
    'users.membership.member_info.account_binding': '第三方註冊',
    'users.membership.member_info.user_credits': '${{count}} 元購物金',
    'users.membership.member_info.member_points': '{{count}} 點會員點數',
    'users.membership.member_info.coupons': '{{count}} 張優惠券',
    'users.membership.forget_password.email_sent':
      '我們已寄出帳號驗證信至{{email}}，\n請收信以繼續重設密碼！',
    'users.member.normal-level': '一般會員',
    'users.membership.expiry_date': '會籍到期日',
    'users.membership.expire.unlimited': '永久有效',
    'users.membership.expire.month_valid': '（效期 {{months}} 個月)',
    'users.membership.tier.expire.date.description':
      '自動更新時間為訂單完成付款後的隔日凌晨，若因取消訂單或退貨未達成升級條件則不會升級。',
    'users.membership.tier.expire.date.auto_downgrade.description':
      '自動更新時間為訂單轉為已完成後的隔日凌晨，若因取消訂單或退貨未達成升級條件則不會升級。',
    'users.membership.tier.extension.date.description':
      '會籍到期時，訂單狀態若因取消訂單或退貨未達成續會條件則不會續會。',
    'users.membership.offer.discount': '專屬優惠',
    'users.membership.upgrade.next_tier': '升級至{{tier_name}}',
    'users.membership.upgrade.next_tier.discount': '，享購物 {{discount}} 折',
    'users.membership.extension.condition': '續會條件',
    'users.membership.extension.status': '續會狀態',
    'users.membership.max_level_tier': '恭喜您已至最高階會員!',
    'users.membership.spending_within_months':
      '{{months}} 個月內累積消費額達 {{spending}} 即可升級',
    'users.membership.spending_single_purchase':
      '單次消費額達 {{spending}} 即可升級',
    'users.membership.all.spending_within_months':
      '{{months}} 個月內累積消費額達 {{spending}}',
    'users.membership.all.spending_single_purchase':
      '單次消費額達 {{spending}}',
    'users.membership.extend_valid_period':
      '會籍效期{{months}}個月內{{type}}消費額達 {{spending}}',
    'users.membership.within_interval': '累積',
    'users.membership.single_purchase': '單次',
    'users.membership.all_tiers': '查看所有會員等級規則',
    'users.membership.all_tiers.condition': '會員等級規則',
    'users.membership.all_tiers.description':
      '會籍期效內若沒達成續會條件，將會自動降級',
    'users.membership.tier.shopping_discount': '購物 {{discount}} 折',
    'users.membership.tier.upgrade.condition': '本階升級條件 :',
    'users.membership.tier.upgrade.condition.dollar':
      '目前沒有高於 {{ dollar }} 的訂單，',
    'users.membership.tier.upgrade.condition.continue': '繼續逛逛！',
    'users.membership.tier.extend': '已達 {{tier}} 續會條件？',
    'users.membership.tier.upgrade.to_next_level.single': '已達升級條件？',
    'users.membership.tier.upgrade.to_next_level.within':
      '{{month}} 個月內累積消費額',
    'users.membership.tier.upgrade.completed': '符合升級資格',
    'users.membership.tier.upgrade.gap_dollar': '差 {{ dollar }} 升級',
    'users.membership.tier.expire.date': '有效期限 :',
    'users.membership.tier.extend.condition': '續會條件 :',
    'users.membership.tier.extend.single_purchase':
      '會籍效期 {{month}} 個月內沒有高於 {{dollar}} 的訂單',
    'users.membership.tier.extend.single_purchase.can_extend':
      '會籍效期 {{month}} 個月內有高於 {{dollar}} 的訂單，到期時將自動續會',
    'users.membership.tier.extend.top_level.single_purchase':
      '會籍內沒有高於 {{dollar}} 的訂單，',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      '會籍內有高於 {{dollar}} 的訂單，恭喜達成！到期時將自動續會',
    'users.membership.tier.extend.within_interval':
      '會籍效期 {{month}} 個月內累積消費 {{spending}}，差 {{dollar}} 續會',
    'users.membership.tier.extend.within_interval.can_extend':
      '會籍效期 {{month}} 個月內累積消費已達 {{dollar}}，到期時將自動續會',
    'users.membership.tier.extend.top_level.within_interval':
      '差 {{dollar}} 續會',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      '恭喜達成！到期時將自動續會',
    'users.membership.tier.expire.month': '{{month}} 個月',
    'users.membership.tier.discount_percentage.caption': '{{ value }}折',

    'membership.profile.birthday': '生日日期',
    'birthday_picker.year.placeholder': '年',
    'birthday_picker.month.placeholder': '月',
    'birthday_picker.date.placeholder': '日',
    'form.validation.birthday.required': '生日日期 是必須的',
    'form.validation.birthday.invalid': '生日日期 無效',
    'form.validation.birthday.invalid.minimum_age_limit':
      '生日日期無效，需大於 {{minimumAgeLimit}} 歲',
    'users.birthday.faq': '你需達到一定年齡才能於網店註冊及購物。',
    'membership.edit.send_me_check_mode': '寄發驗證碼',
    'membership.edit.select_saved_mobile_number': '選擇儲存的聯絡電話',
    'session.mobile_signup.check_mobile.title':
      '請確認您的手機號碼是否輸入正確，我們將傳送簡訊到以下手機號碼',
    'session.mobile_signup.check_mobile.your_number': '您的手機號碼',
    'session.mobile_signup.check_mobile.send_code': '寄發驗證碼',
    'session.mobile_signup.check_mobile.go_back.1': '若手機號碼有誤，請回',
    'session.mobile_signup.check_mobile.go_back.2': '上一步',
    'session.mobile_signup.check_mobile.go_back.3': '修改',
    'session.mobile_signup.check_mobile.go_back.3.simplified': '修改',
    'session.mobile_signup.input_code.hint': '請輸入收到的簡訊驗證碼',
    'session.mobile_signup.input_code.hint.simplified': '請輸入您收到的驗證碼',
    'session.mobile_signup.input_code.placeholder': '驗證碼',
    'session.mobile_signup.input_code.submit': '送出',
    'session.mobile_signup.input_code.resend.countdown':
      '重發驗證碼 ({{resendCountdown}}秒)',
    'session.mobile_signup.input_code.resend.countdown.simplified':
      '重新發送({{resendCountdown}}秒）',
    'session.mobile_signup.input_code.resend': '重發驗證碼',
    'session.mobile_signup.input_code.resend.simplified': '重新發送',
    'session.forget_passowrd.check_phone.error': '手機號碼無效，請重新確認',
    'session.forget_passowrd.error': '電郵或手機號碼無效',
    'session.mobile_center.check_phone.error': '此手機號碼已註冊過',
    'user.sign_up.check_phone.error':
      '此為現有手機號碼，請重新填寫需要更換的號碼。',
    'membership.profile.mobile.number.verified':
      '會員手機驗證完成，並將取代已儲存的電話號碼以利辨識',
    'membership.profile.delivery_addresses': '儲存的地址',
    'users.add.delivery_address.maximum': '最多只能有五個送貨地址',
    'users.add.delivery_address': '新增送貨地址',
    'checkout.address.recipient': '收件人',
    'checkout.address.recipient_phone': '收件人電話號碼',
    'member_profile.line.subscribe.error.already_in_used':
      '此 LINE 帳號已被其他會員使用，請聯絡店家！',
    'member_profile.subscribe': '訂閱',
    'member_profile.subscribed': '已訂閱',
    'member_profile.notification.promotion': '優惠宣傳',
    'member_profile.notification.order': '訂單通知',
    'member_profile.subscribe.successfully': '訂閱成功',
    'member_profile.subscribe.error': '訂閱失敗，請聯絡店家',
    'member_profile.line.subscribe.error.already_for_registration':
      '訂閱失敗，此 LINE 帳號已被其他會員註冊使用，請用 LINE 登入該帳號再訂閱',
    'member_profile.line.subscribe.error.different_id':
      '訂閱失敗，請用註冊此會員的 LINE 帳號訂閱',
    'member_profile.line.subscribe.error': '訂閱失敗，請重新登入 LINE',
    'member_profile.facebook.subscribe.error': '訂閱失敗，請重新登入 FB',
    'member_profile.social.subscribe.error.already_bound_to':
      '訂閱失敗，此社群帳號已綁定其他顧客，請聯絡店家解除綁定',
    'member_profile.email.subscribe.error': '訂閱失敗，請先輸入電郵後再訂閱',
    'member_profile.sms.subscribe.error': '訂閱失敗，請先輸入手機號碼後再訂閱',
    'member_profile.unsubscribe.successfully': '取消訂閱成功',
    'member_profile.unsubscribe.error': '取消訂閱失敗，請再試一次',
    'member_profile.error.unknown': '對不起！遇到非預期的狀況',
    'member_profile.error.refresh': '請重新整理此頁並稍後再試',
    'member_profile.retry': '重新整理',
    'member_profile.profile': '會員資料',
    'member_profile.subscription': '訂閱',
    'member_profile.delivery_payment': '送貨與付款資料',
    'member_profile.phone': '聯絡電話',

    'user.credit_card.title': '信用卡',
    'user.credit_card.information': '信用卡資訊 (最多綁定 {{ max }} 張)',
    'user.add_credit_card': '新增信用卡',
    'user.add_credit_card.credit_card_limit': '最多綁定 {{ max }} 張卡片',
    'user.add_credit_card.success': '卡片新增成功',
    'user.add_credit_card.fail': '卡片新增失敗，請重新嘗試',
    'user.add_credit_card.cancel': '取消',
    'user.add_credit_card.remind':
      '提醒：新增信用卡時，SHOPLINE Payments 將會取得一次 {{ label }} 元的授權紀錄，此筆授權紀錄不會請款。',
    'user.add_credit_card.submit': '提交',
    'user.delete_credit_card': '您確定要刪除此張卡片？',
    'user.delete_credit_card.description':
      '刪除此信用卡後將無法使用此卡快速支付',
    'user.delete_credit_card.description.with_subscription_product':
      '刪除此信用卡後將無法使用此卡快速支付。若您曾用此張卡片購買定期購商品，產生下期訂單時可能導致付款失敗，屆時請至會員中心 > 訂單頁重新付款。',
    'user.delete_credit_card.success': '卡片刪除成功',
    'user.delete_credit_card.fail': '刪除失敗，請重新嘗試',
    'user.delete_credit_card.cancel': '取消',
    'user.delete_credit_card.delete': '確定刪除',
    'user.credit_card.expired': '卡片已過期',
    'user.credit_card_list.delete': '刪除',
    'user.credit_card_list.processing': '新增中',
    'users.invoice_carrier': '發票載具',
    'users.electronic_invoice_carrier': '電子發票載具歸戶',
    'member_profile.confirm': '儲存變更',
    'member_profile.cancel': '取消',
    'users.save.success': '已儲存變更',
    'users.error.not_save_mobile_phone': '此手機號碼尚未驗證，無法儲存變更',
    'verification.email.trial_merchant.reach_limit.failure':
      '商店試營運中，無法發送驗證郵件，如有需求請聯繫商店。',
    'Subscription - Facebook - Dialog - title': '訂閱 Facebook',
    'Subscription - Facebook - Dialog - info': `因應 Facebook 平台的訊息規範更新，須至 Messenger 完成訂閱流程。請點按「前往訂閱」，系統將自動開啟 Messenger。<1 /> 開啟 Messenger 後，請登入並<2>點按對話中的「立即開始」按鈕</2>再回到本頁面，即可完成訂閱。（若您曾與此商店的粉絲專頁對話過，開啟對話後即視為訂閱成功。）`,
    'Subscription - Facebook - Dialog - cancel': '取消',
    'Subscription - Facebook - Dialog - subscribe': '前往訂閱',
  },
};
